<ng-template>
    <spinner [show]="true"></spinner>
</ng-template>

<spinner [show]="true" *ngIf="carregando" class="loading"></spinner>

